import { gql } from "@apollo/client";

export const DeleteInstalledBaseNodeAttribute = gql`
    mutation DeleteInstalledBaseNodeAttribute ($id: ID!){
        deleteInstalledBaseNodePropertyDefinition(id: $id) {
            success
            message
        }
    }
`;
